export * from './textResultsTemplate.service';